import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { renderToStaticMarkup } from "react-dom/server";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Storage from "react-native-storage";
import i18n from "i18n-react";
import SweetAlert from "sweetalert-react";

import { UserInfoProvider } from "hooks/useUserInfo";
import { SettingsProvider } from "hooks/useSettings";
import { PointsHandlerProvider } from "hooks/usePointsHandler";

// FontAwesome
import "config/FontAwesome";

import {
  AppSettings,
  APIHandler,
  AppRouter,
  DataHandler,
  locales,
  StorageHandler,
  CookieWarning,
} from "C4";
import { storageKeys, language, userKeys } from "settings";

import "normalize.css/normalize.css";
import "./assets/styles/styles.scss";

const { cookieEnabled } = window.navigator;

const exportObject = cookieEnabled
  ? new Storage({
      storageBackend: cookieEnabled ? window.localStorage : {},
      defaultExpires: 1000 * 3600 * 24, // 1 day = (1000 * 3600 * 24 milliseconds), null = never expire
      enableCache: true,
      sync: {
        // TODO: Handle exiration of data (Reload data with new API Calls)
      },
    })
  : {};

export default exportObject;

i18n.setTexts(locales.en); //  setTexts i18n based on localstorage lang fix both on page load

const availableLanguages = language
  .map(({ code }) =>
    typeof code === "string" ? code : code.map((c) => c.toLowerCase())
  )
  .flat();
const commitRisk = language.some(
  (lang) => lang.id === 220 && lang.countries.length > 0
);
if (commitRisk) {
  console.error(
    "One of the testing languages is currently in use. Please remove before committing."
  );
}

const params = new URLSearchParams(window.location.search);

DataHandler.matchAppId().then((appId) => {
  StorageHandler.load(storageKeys.appId).then((id) => {
    if (id !== appId) {
      StorageHandler.removeKeys(
        Object.keys(storageKeys).filter((key) => {
          const k = storageKeys[key];
          return k !== storageKeys.appId && k !== storageKeys.lang;
        })
      );
      StorageHandler.save(storageKeys.appId, appId);
    } else {
      StorageHandler.save(storageKeys.appId, id);
    }
    StorageHandler.load(storageKeys.lang).then((lang) => {
      i18n.setTexts(locales[lang.langFile]);
    });
    if (sessionStorage.getItem(sessionStorage.key("tt_sessionId")) !== "-1") {
      StorageHandler.load(storageKeys.user).then((res) => {
        if (res) {
          const { email } = res;
          APIHandler.lastActive(appId, email);
          sessionStorage.setItem(sessionStorage.key("tt_sessionId"), -1);
        }
      });
    }
  });
  window.appId = appId;
});

if (cookieEnabled) {
  // Check if language is already set, proceed said language.
  StorageHandler.exists(storageKeys.lang).then((languageExists) => {
    if (languageExists) {
      if (params.get("lang")) {
        let newLanguageCode = params.get("lang").toLowerCase();
        if (newLanguageCode === "undefined") {
          newLanguageCode = "en";
        }
        const newCountry = language.filter(
          (langSettings) => langSettings.langFile === newLanguageCode
        )[0].countries[0];
        StorageHandler.save(storageKeys.lang, {
          country: newCountry,
          code: newLanguageCode.toUpperCase(),
          langFile: newLanguageCode,
        });
        i18n.setTexts(locales[params.get("lang")]);
      } else {
        StorageHandler.load(storageKeys.lang).then((lang) => {
          i18n.setTexts(locales[lang.langFile]);
        });
      }
    } else if (params.get("lang")) {
      let newLanguageCode = params.get("lang").toLowerCase();
      if (newLanguageCode === "undefined") {
        newLanguageCode = "en";
      }

      const newCountry = language.filter(
        (langSettings) => langSettings.langFile === newLanguageCode
      )[0].countries[0];
      StorageHandler.save(storageKeys.lang, {
        country: newCountry,
        code: newLanguageCode.toUpperCase(),
        langFile: newLanguageCode,
      });
      window.location.reload();
    } else {
      const browserLanguage =
        window.navigator.language || window.navigator.userLanguage;
      if (availableLanguages.includes(browserLanguage)) {
        const newCountry = language.filter(
          (langSettings) => langSettings.langFile === browserLanguage
        )[0].countries[0];
        StorageHandler.save(storageKeys.lang, {
          country: newCountry,
          code: browserLanguage.toUpperCase(),
          langFile: browserLanguage,
        });
        i18n.setTexts(locales[browserLanguage]);
      } else {
        StorageHandler.save(storageKeys.lang, {
          country: "United States",
          code: "EN",
          langFile: "en",
        });
        i18n.setTexts(locales.en);
      }
      window.location.reload();
    }
  });

  StorageHandler.load("askedMobile").then((askedBefore) => {
    ReactDOM.render(
      <App askedBefore={askedBefore} />,
      document.getElementById("root")
    );
  });
}

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      askedBefore: this.props.askedBefore,
      loading: true,
    };
  }

  componentDidMount() {
    this.setLoader();
  }

  setLoader() {
    AppSettings().then((res) => {
      if (res) {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    const { askedBefore, loading } = this.state;

    const setAsked = () => {
      // this.setState({ askedBefore: true });
      // StorageHandler.save('askedMobile', true);
      window.history.back();
    };

    return (
      <div className="container__router">
        {!cookieEnabled && <CookieWarning />}
        {loading && (
          <div className="appLoader">
            <FontAwesomeIcon icon={["fas", "circle-notch"]} spin />
          </div>
        )}
        {!loading && (
          <SettingsProvider>
            <UserInfoProvider>
              <PointsHandlerProvider>
                <AppRouter />
              </PointsHandlerProvider>
            </UserInfoProvider>
          </SettingsProvider>
        )}
      </div>
    );
  }
}

App.propTypes = {
  askedBefore: PropTypes.bool.isRequired,
};
